var render, staticRenderFns
import script from "./dui-tabs.vue?vue&type=script&lang=js&"
export * from "./dui-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66415732",
  null
  
)

export default component.exports